import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import * as serviceWorker from "./serviceWorker";
import { createBrowserHistory } from "history";
import createStore from "./store";

async function main() {
  const history = createBrowserHistory();
  const store = createStore(history);
  const root = document.getElementById("root");
  ReactDOM.render(React.createElement(Root, { history, store }, null), root);
}

document.addEventListener("DOMContentLoaded", () => main());
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
